import React from 'react';
import Navbar from './Navbar'
import '../acheivments.css'
import AwardData from './data/awards.json'

class Acheivments extends React.Component{
    render(){
        return(
            <div>
                <Navbar/>
                {AwardData.map((awardDetail) => {
                    return(
                    <h1>{awardDetail.acheivments}</h1> 
                    )
                })}
            </div>





            // <div>
            //     <Navbar />
            //     <p className="heading">2020</p>
            //     <p className="sub-heading">September</p>
            //         <ul>
            //             <li className="acheivments">Hello</li>
            //         </ul>
            // </div>
        )
    }
}

export default Acheivments